import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <h3 className="chapter__title">Green is More Than a Color. It’s a Mindset</h3>
        <p className="chapter__paragraph">
          Beyond color, auto finishes are becoming more interesting inside and out. “For me, some of
          the more putty-like finishes and earthy, muted colors out there feel like an expression of
          love for the environment,” James, a prospective buyer, told us. “I don’t want my new truck
          to clash with nature. I want it to look like it was carved from granite.”
        </p>
        <p className="chapter__paragraph">
          Sustainability is a major point of emphasis across myriad sections of the automotive
          industry, especially as companies move towards more efficient and “greener” vehicles. Car
          manufacturers are adapting their designs to include more nontraditional materials: wool
          upholstery, reclaimed driftwood, recycled aluminum, and interior materials made from
          durable, recycled plastic bottles and newspapers are all becoming more common. BASF takes
          this development approach too. “What we aim to do is not only introduce new colors, but
          we're also thinking about what the world might look like in the future,” says Hoffman, “so
          that's quite exciting, to be a part of a team of futurists.”
        </p>
      </section>
    </>
  );
}

export default Chapter3;
